import { isValidPhoneNumber } from "react-phone-number-input";
import { z } from "zod";
import {
  invalidPlatformUrl,
  invalidUrl,
  validatePlatformUrl,
} from "../structure";

const optionalZodUrl = z
  .union([z.string().url({ message: "URL invalide" }), z.string().length(0)])
  .nullable()
  .optional();

export const createExhibitorFromCsvSchema = z.object({
  businessName: z.string().min(1, "Veuillez entrer un nom"),
  businessSector: z.string().nullable().optional(),
  businessEmail: z.string().email("Email invalide"),
  phoneNumber: z
    .union([
      z.string().refine((phone) => isValidPhoneNumber(phone, "FR"), {
        message: "Téléphone invalide",
      }),
      z.string().length(0),
    ])
    .nullable()
    .optional(),
  address: z.string().nullable().optional(),
  city: z.string().nullable().optional(),
  zipCode: z.string().nullable().optional(),
  websiteUrl: optionalZodUrl,
  linkedinUrl: z
    .string()
    .url(invalidUrl)
    .refine(validatePlatformUrl(["linkedin.com"]), {
      message: invalidPlatformUrl("LinkedIn"),
    })
    .or(z.literal(""))
    .nullish(),
  facebookUrl: z
    .string()
    .url(invalidUrl)
    .refine(validatePlatformUrl(["facebook.com"]), {
      message: invalidPlatformUrl("Facebook"),
    })
    .or(z.literal(""))
    .nullish(),
  twitterUrl: z
    .string()
    .url(invalidUrl)
    .refine(validatePlatformUrl(["twitter.com", "x.com"]), {
      message: invalidPlatformUrl("X (Twitter)"),
    })
    .or(z.literal(""))
    .nullish(),
  instagramUrl: z
    .string()
    .url(invalidUrl)
    .refine(validatePlatformUrl(["instagram.com"]), {
      message: invalidPlatformUrl("Instagram"),
    })
    .or(z.literal(""))
    .nullish(),
  youtubeUrl: z
    .string()
    .url(invalidUrl)
    .refine(validatePlatformUrl(["youtube.com"]), {
      message: invalidPlatformUrl("YouTube"),
    })
    .or(z.literal(""))
    .nullish(),
});

export type CreateExhibitorFromCsvSchema = z.infer<
  typeof createExhibitorFromCsvSchema
>;

export type NewExhibitor = CreateExhibitorFromCsvSchema & {
  id: string;
  saveId: string | null;
  originLabel?: string;
};
